import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login/Login';
import Status from './pages/Status/Status';
import ComingSoon from './pages/ComingSoon/ComingSoon';

/**
 * Componente de definição das rotas da aplicação.
 *
 * @component
 * @returns {JSX.Element} Retorna o componente BrowserRouter com a rota definida.
 */
function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route path="/login" element={<Login />} />
        <Route path="/status" element={<Status />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
